import { DecimalPipe } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  input,
} from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { WuiPreviewTableComponent } from 'wflow-ui';
import { DocumentLine } from 'wflow-main-app/src/app/core/api/model/documents/detail-document';

@Component({
  selector: 'wf-peppol-ubl-preview-lines',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [DecimalPipe, TranslateModule, WuiPreviewTableComponent],
  templateUrl: './peppol-ubl-preview-lines.component.html',
})
export class PeppolUblPreviewLinesComponent {
  readonly lines = input.required<DocumentLine[]>();
}
